<template>
  <div class="container" >
    <div class="contact-card" >
      <div class="tip" >
        <p class="title" >联系我们</p>
        <p class="content" >不同层面的行业信息化解决方案咨询</p>
      </div>
      <div class="center" >
        <div class="info-com">
          <div class="info-box1">
            <p class="name">南京微未信息科技有限公司</p>
            <div>
              <p>商务联系: <span>Kelly Zan</span></p>
              <p>联系电话: <span>17701731252</span></p>
              <p>客服邮箱: <span>service@mail.wefuture.org.cn</span></p>
              <p>南京公司: <span>南京市玄武区珠江路88号A座4410室</span></p>
              <p>上海公司: <span>上海市静安区江场西路299弄5号楼4层</span></p>
            </div>
          </div>
          <div class="info-box2">
            <div class="info-box2_box" >
              <img src="./qr-code.png" alt="">
              <div>扫码免费试用</div>
            </div>
          </div>
        </div>
        <div class="form" >
          <div class="input-box" >
            <input ref="input-name" placeholder="姓名" type="text" >
            <input ref="input-contact" placeholder="联系方式" type="text" >
            <input ref="input-brand" placeholder="公司品牌" type="text" >
            <input ref="input-num" placeholder="门店数量" type="text" >
          </div>
          <textarea ref="input-memo" placeholder="留言建议" rows="10" ></textarea>
          <button id="submit" type="button" value="提交" name="submit" @click="applyTrial" >申请试用</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { appthirdprobation } from "@/api/index.js"

export default {
  components: {},
  data () {
    return {

    }
  },
  computed: {},
  watch: {},
  methods: {
    applyTrial () {
      const params = {
        type: "B",
        productline: "B",
        appperson: this.$refs['input-name'].value,
        mobilephone: this.$refs['input-contact'].value,
        corporatename: this.$refs['input-brand'].value,
        storesnum: this.$refs['input-num'].value,
        memo: this.$refs['input-memo'].value,
        uid: "8888",
        debug: "weiweikeji"
      }

      appthirdprobation(params).then((e) => {
        console.log(e)
      })
    },
  }
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container {
  height: auto;
  width: 100%;
  background-color: #1a2029;

  .contact-card {
    min-height: calc(100vh - 60px - 50px);
    padding: 40px 0;
    width: 70%;
    margin: 0 auto;
    box-sizing: border-box;

    @media screen and (max-width: 750px) {
      height: auto;
      width: 90%;
      text-align: center;
    }
  
    .tip {
      text-align: center;
      color: #eee;
  
      .title {
        font-size: 25px;
        font-weight: 500;
      }
  
      .content {
        font-size: 15px;
        margin-bottom: 30px;
      }
      @media screen and (max-width: 500px){
        .title {
          font-size: 18px;
        }

        .content {
          font-size: 12px;
        }
      }
    }
  
    .center {
      color: #475870;
      margin-top: 40px;
  
      .info-com {
        width: 100%;
        display: flex;

        @media screen and (max-width: 750px) {
          flex-direction: column;
          align-items: center;
        }

        
  
        .info-box1 {
          width: calc(100% - 120px);
  
          .name {
            font-size: 16px;
            margin-bottom: 20px;
          }
  
          p {
            margin: 0 0 8px 0;
          }
        }
  
        .info-box2 {
          width: 120px;
          display: flex;
          justify-content: flex-end;
  
          &_box {
            display: flex;
            flex-direction: column;
            align-items: center;
  
            img {
              width: 120px;
              height: 120px;
            }
  
            div {
              margin-top: 20px;
              width: fit-content;
            }
          }
        }
      }
  
      .form {
  
        .input-box {
          display: flex;
          justify-content: space-between;
          margin-top: 20px;
  
          input {
            width: 19%;
            height: 46px;
            background: #202833;
            color: #475870;
            text-align: center;
            border: 2px solid #2A3442;
            font-size: 15px;
            padding: 0 1rem;

            @media screen and (max-width: 500px) {
              font-size: 12px;
            }
          }

          @media screen and (max-width: 750px) {
            flex-direction: column;

            input {
              width: 100%;
              box-sizing: border-box;
              margin-bottom: 20px;
            }
          }
        }
  
        textarea {
          width: calc(100% - 2px);
          margin-top: 40px;
          height: 200px;
          background: #202833;
          color: #475870;
          text-align: left;
          border: 2px solid #2A3442;
          resize: none;
          padding: 10px;
          box-sizing: border-box;
          font-size: 15px;

          @media screen and (max-width: 500px) {
            font-size: 12px;
          }
        }
  
        #submit {
          width: 100%;
          margin: 40px 0 60px;
          background: #4b9eea;
          height: 50px;
          line-height: 50px;
          text-align: center;
          border: 0;
          border-radius: 4px;
          color: #eee;
          font-size: 16px;
          @media screen and (max-width: 500px) {
            font-size: 12px;
          }
        }
      }

      @media screen and (max-width: 500px) {
        font-size: 12px;

        .info-com {
          .info-box1 {
            .name {
              font-size: 14px;
            }
          }
        }

        input {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
